export default __webpack_public_path__ + "static/media/red_girl_img.a1bf609a.png";